import { arTexts } from "./ar";
import { faTexts } from "./fa";
import { enTexts } from "./en";
import { duTexts } from "./du";
import Cookies from "js-cookie";
import { supportedLanguages } from "../settings";

export default function languagePicker(query = null, lang = null) {
  let cookieLanguage = Cookies.get("language");
  let queryLanguage = new URLSearchParams(query).get("lang");
  let language = "fa";

  if (supportedLanguages.indexOf(queryLanguage) >= 0) {
	language = queryLanguage
  } else if (supportedLanguages.indexOf(lang) >= 0) {
    language = lang;
  } else if (supportedLanguages.indexOf(cookieLanguage) >= 0) {
    language = cookieLanguage;
  }

  if (!cookieLanguage || cookieLanguage !== language) {
    Cookies.set("language", language, { expires: 1095 });
  }

  let themeDirection = themeDirectionPicker(language);
  let texts = textsPicker(language);

  return { texts, language, themeDirection };
}

export function textsPicker(language) {
  switch (language) {
    case "ar":
      return arTexts;
    case "en":
      return enTexts;
    case "du":
      return duTexts;
    default:
      return faTexts;
  }
}

export function themeDirectionPicker(language) {
  switch (language) {
    case "fa":
    case "ar":
      return "rtl";
    default:
      return "ltr";
  }
}

export function getLanguageFlag(language) {
  switch (language) {
    case "fa":
      return "/static/img/iran.png";
    case "ar":
      return "/static/img/ar.png";
    case "du":
      return "/static/img/du.png";
    default:
      return "/static/img/uk.png";
  }
}
